<template>
  <aside class="hero-panel">
    <div class="hero-bg">
      <div class="hero-blob hb1"></div>
      <div class="hero-blob hb2"></div>
      <div class="hero-blob hb3"></div>
    </div>

    <div class="hero-brand">
      <a :href="site_url" class="hero-logo" aria-label="Linktone"></a>
    </div>

    <div class="hero-copy">
      <div class="hero-tag">
        <span class="hero-tag-dot"></span>
        הצטרפות אומנים
      </div>
      <h2 class="hero-headline">
        המוזיקה שלכם<br />
        <span class="hero-headline-pink">בכל פלטפורמה.</span>
      </h2>
      <p class="hero-deck">
        הקליפים והאלבומים שלכם מגיעים לרדיו, פלייליסטים וקטלוג Linktone — מכאן.
      </p>
    </div>

    <div class="hero-preview">
      <div class="hero-preview-label">תצוגה מקדימה של עמוד האומן</div>
      <div class="hero-card">
        <div class="hero-card-photo">
          <img v-if="data.photo" :src="data.photo.url" alt="" />
          <div v-else class="hero-card-photo-empty">
            <LtIcon name="user" :size="28" />
          </div>
        </div>
        <div class="hero-card-meta">
          <div class="hero-card-name">{{ data.artistName || 'השם שלכם' }}</div>
          <div class="hero-card-genres">
            <template v-if="selectedGenreNames.length">
              <span v-for="name in selectedGenreNames" :key="name" class="hero-card-genre">{{ name }}</span>
            </template>
            <span v-else class="hero-card-genre muted">סגנונות מוזיקה</span>
          </div>
        </div>
      </div>
    </div>

    <div class="hero-footnote">
      <LtIcon name="lock" :size="14" />
      הנתונים שלכם מאובטחים ולא משותפים ללא רשותכם
    </div>
  </aside>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { genreNamesForIds } from './data.js';

export default {
  name: 'HeroPanel',
  components: { LtIcon },
  props: { data: { type: Object, required: true } },
  computed: {
    selectedGenreNames() {
      return genreNamesForIds(this.$store.genres, this.data.genres);
    },
  },
}
</script>
